import { FormUserMessages, TranslationFormUserMessages } from "../interfaces";

export const messages: TranslationFormUserMessages = {
  [FormUserMessages.fieldEmail]: "Email",
  [FormUserMessages.fieldName]: "Nombre",
  [FormUserMessages.fieldPosition]: "Trabajo",
  [FormUserMessages.fieldDescription]: "Descripción",
  [FormUserMessages.fieldActive]: "Este usuario está activo",
  [FormUserMessages.fieldInactive]: "Este usuario está inactivo",
  [FormUserMessages.addImage]: "Agregar foto",
  [FormUserMessages.removeImage]: "Eliminar foto",
  [FormUserMessages.deletionConfirmationTitleModal]: "Confirmación de eliminación",
  [FormUserMessages.deletionConfirmationSubtitleModal]: "Al confirmar, el usuario será eliminado de todas las soluciones de Topcon. "
      + "Estás seguro de que quieres continuar?"
};